import React from "react";
import "./App.css";

//Components
import Pomodoro from "./components/Pomodoro";

function App() {
  return (
    <div className="App">
      <Pomodoro />
    </div>
  );
}

export default App;
